"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _event = _interopRequireDefault(require("../../shared/event"));

var _utils = require("../../shared/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * pageView auto track
 *
 * @param {*} scout
 */
var timer = null;

function getPageName(scout) {
  var curPath = window.location.pathname;
  var pageName = scout.options.pageNames[curPath] || ''; // 如果没有pageName且路径是'/a/b/c'形式，转为'a_b_c'

  if (!pageName) {
    pageName = curPath.replace(/\//g, '_').substring(1);
  }

  return pageName;
}

function init(scout) {
  // 如果没开启单页面自动上报或者已经初始化过了，就不往下走
  if (!scout.options.trackSinglePage) return; // 创建新的 pushState、replaceState 全局监听事件

  window.history.pushState = rw('pushState');
  window.history.replaceState = rw('replaceState'); // 监听 pushState、replaceState 事件

  _event["default"].addEvent(window, 'pushState', handleHistoryChange.bind(null, scout));

  _event["default"].addEvent(window, 'replaceState', handleHistoryChange.bind(null, scout)); // 监听页面第一次加载完成


  _event["default"].addEvent(window, 'load', handleHistoryChange.bind(null, scout)); // URL 回退默认都会触发 popstate 事件


  _event["default"].addEvent(window, 'popstate', handleHistoryChange.bind(null, scout));
}
/**
 * 创建新的事件类型
 * @param {string} type 事件类型
 */


function rw(type) {
  var org = window.history[type];
  return function () {
    var rv = org.apply(this, arguments);
    var e = new CustomEvent(type);
    e.arguments = arguments;
    window.dispatchEvent(e);
    return rv;
  };
}
/**
 * 事件处理函数
 * @param {*} scout scout实例
 */


function handleHistoryChange(scout, e) {
  var pageName = getPageName(scout); // 每次路由跳转，先清除之前的延时定时器

  if (timer) {
    clearTimeout(timer);
    timer = null;
  }

  if (pageName) {
    // 第一次加载完成，马上上报PV
    if (e.type === 'load') {
      scout.track('page', {
        page: pageName
      }); // 延时发送，避免无法获取到window.performance.loadEventEnd的数据

      setTimeout(function () {
        // 第一次页面加载，上面首页性能埋点事件
        scout.track('fe_performance', (0, _utils.getPerformanceData)());
      }, 800);
      return;
    } // 延时发送，避免无效的PV


    if (scout.options.pageDelayTime <= 0) {
      // 立即发送，不延时发送
      scout.track('page', {
        page: pageName
      });
    } else {
      // 延时发送
      var time = scout.options.pageDelayTime || 1000;
      timer = setTimeout(function () {
        scout.track('page', {
          page: pageName
        });
      }, time);
    }
  }
}

var _default = {
  init: init,
  name: 'pageView'
};
exports["default"] = _default;